<fgb-page-header [pageTitle]="'nav.archievements'" [backButtonLink]="'/'"></fgb-page-header>

<fgb-banner [bannerTitle]="'nav.archievements' | translate"></fgb-banner>

<div class="container">
  <fgbcl-badge-achieved />
</div>

<fgbcl-scorecard-list-view [icon]="'chevron_right'" [showPlaceholder]="true"></fgbcl-scorecard-list-view>
